import type {MetaFunction} from '@remix-run/node';

export const meta: MetaFunction = function NotFoundMeta() {
  return [{title: 'CINDEDI'}, {name: 'description', content: 'Whoops'}];
};

export default function NotFoundView() {
  return <div style={{lineHeight: '1.8'}}>somethings wrong isn&apos;t right</div>;
}
